import { render, staticRenderFns } from "./ItemSkeleton.vue?vue&type=template&id=e36a1d9a&"
import script from "./ItemSkeleton.vue?vue&type=script&lang=js&"
export * from "./ItemSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ItemSkeleton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports